import {
  LIST_SLA_RESULT_REQUEST,
  LIST_SLA_RESULT_SUCCESS,
  LIST_SLA_RESULT_FAIL,
  EXPORT_SLA_RESULT_REQUEST,
  EXPORT_SLA_RESULT_SUCCESS,
  EXPORT_SLA_RESULT_FAIL,
  LIST_EXPORT_SLA_RESULT_REQUEST,
  LIST_EXPORT_SLA_RESULT_SUCCESS,
  LIST_EXPORT_SLA_RESULT_FAIL,
  LIST_BULK_SLA_REQUEST,
  LIST_BULK_SLA_SUCCESS,
  LIST_BULK_SLA_FAIL,
  DETAIL_BULK_SLA_REQUEST,
  DETAIL_BULK_SLA_SUCCESS,
  DETAIL_BULK_SLA_FAIL,
  DETAIL_SLA_EXTENDED_REQUEST,
  DETAIL_SLA_EXTENDED_SUCCESS,
  DETAIL_SLA_EXTENDED_FAIL,
  POST_EXTENDED_SLA_REQUEST,
  POST_EXTENDED_SLA_SUCCESS,
  POST_EXTENDED_SLA_FAIL
} from '../../constants/sla-result'

const initalState = {
  slaResultList: [],
  slaExportResultList: [],
  slaBulkUpdateList: [],
  detailProcessBulkSlaData: {},
  detailSlaExtended: null,
  pageable: {
    page: 1,
    size: 10
  },
  loading: false,
  loadingExport: false,
  loadingDetail: false,
  error: ''
}

const slaResultListReducer = (state = initalState, action) => {
  switch (action.type) {
    case LIST_SLA_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_SLA_RESULT_SUCCESS:
      return {
        ...state,
        slaResultList: action.payload,
        pageable: action.pageable,
        loading: false,
        error: null
      }
    case LIST_SLA_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        slaResultList: action.dummy
      }
    case EXPORT_SLA_RESULT_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_SLA_RESULT_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_SLA_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingExport: false
      }
    case LIST_EXPORT_SLA_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_EXPORT_SLA_RESULT_SUCCESS:
      return {
        ...state,
        slaExportResultList: action.payload,
        loading: false,
        error: null
      }
    case LIST_EXPORT_SLA_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case LIST_BULK_SLA_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_BULK_SLA_SUCCESS:
      return {
        ...state,
        slaBulkUpdateList: action.payload,
        pageable: action.pageable,
        loading: false,
        error: null
      }
    case LIST_BULK_SLA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        slaBulkUpdateList: action.dummy
      }
    case DETAIL_BULK_SLA_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_BULK_SLA_SUCCESS:
      return {
        ...state,
        loading: false,
        detailProcessBulkSlaData: action?.payload,
        error: null
      }
    case DETAIL_BULK_SLA_FAIL:
      return {
        ...state,
        loading: false,
        error: action?.payload,
        detailProcessBulkSlaData: action?.dummy
      }
    case DETAIL_SLA_EXTENDED_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_SLA_EXTENDED_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailSlaExtended: action.payload
      }
    case DETAIL_SLA_EXTENDED_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingDetail: false,
        detailSlaExtended: null
      }
    case POST_EXTENDED_SLA_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case POST_EXTENDED_SLA_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case POST_EXTENDED_SLA_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingExport: false
      }
    default:
      return state
  }
}

export default slaResultListReducer
